// polyfills
require('core-js/fn/array/from');
require('./modules/polyfills')();

// detect mobile devices
require('./modules/mobileDetect')();

// external svg support for old browsers
require('svgxuse');

// jQuery
window.jQuery = window.$ = require('jquery');

// form validation
require('parsleyjs');
require('parsleyjs/dist/i18n/ru.js');

const overlay = window.overlay = require('./modules/overlay');
const popup = window.popup = require('./modules/popup');

const preload = require('./modules/preload');
const initModules = window.initModules = () => {
    popup();

    require('./modules/clients')();
    require('./modules/placeholder')();
    require('./modules/file')();
    require('./modules/animate')();
    require('./modules/scrollTo')();
    require('./modules/header')();
    require('./modules/iframeScrollToTop')();
    require('./modules/logo')();
    require('./modules/promo')();
    require('./modules/feedback')();
    require('./modules/works')();
    require('./modules/animatedWork')();
    require('./modules/accordion')();
    require('./modules/stages')();
    require('./modules/stages-2')();
    require('./modules/stages-3')();
    require('./modules/tech-s')();
    require('./modules/tools-slider')();
    require('./modules/currentYear')();

    if (typeof initWorkModules === 'function') initWorkModules();
};

// init modules on page load
if (document.readyState === 'complete') {
    if (!document.body.classList.contains('preload')) {
        initModules();
    } else {
        preload(initModules);
    }
} else if (document.readyState === 'interactive' && !document.body.classList.contains('preload')) {
    initModules();
} else {
    document.addEventListener('DOMContentLoaded', () => {
        if (!document.body.classList.contains('preload')) {
            initModules();
        }
    });

    window.addEventListener('load', () => {
        if (document.body.classList.contains('preload')) {
            preload(initModules);
        }
    });
}

// if (document.readyState === 'complete' || document.readyState === 'interactive') {
//     if (!document.body.classList.contains('preload')) {
//         initModules();
//     } else {
//         preload(initModules);
//     }
// } else {
//     document.addEventListener('DOMContentLoaded', () => {
//         if (document.body.classList.contains('preload')) {
//             preload(initModules);
//         } else {
//             initModules();
//         }
//     });
// }